// extracted by mini-css-extract-plugin
export var phone = "_3n-0";
export var phoneDragging = "_3n-1";